import React from 'react';
import {connect} from 'react-redux';

import strings from '../../utils/strings';

import {goToNextStep, setTestStepAnswers} from '../../actions/index';

import './styles.scss';

import {TEST_STEPS} from '../../constants';

import Intro from './Intro';
import Tutorial from './Tutorial';
import Test from './Test';
import currentStepIndex from '../../reducers/currentStepIndex';

const subSteps = [Intro, Test]; //The tutorials are only available for german test
const subStepsDE = [Intro, Tutorial, Test]; //The tutorials are only available for german test

const titles = [strings.orddiktat, strings.orddiktat];
const titlesDE = [
	strings.orddiktat,
	strings.orddiktat_trial,
	strings.orddiktat,
];

class Orddiktat extends React.Component {
	constructor() {
		super();

		this.handleNextSubstep = this.handleNextSubstep.bind(this);

		this.state = {
			currentSubstepIndex: 0,
			isSubmitting: false,
		};

		this.audioRefs = {};
	}

	handleNextSubstep(results) {
		const {currentSubstepIndex} = this.state;
		const {candidateGrade} = this.props;

		const {onGoToNextStep, onSetTestStepAnswers} = this.props;

		const substepsLength =
			strings.getLanguage() === 'de'
				? subStepsDE.length - 1
				: subSteps.length - 1;

		const isLastStep = currentSubstepIndex === substepsLength;

		if (isLastStep) {
			const resultKeys = Object.keys(results);
			const formattedResults = resultKeys.map((id) => {
				const value = results[id];
				return {
					id,
					value,
				};
			});
			onSetTestStepAnswers(
				TEST_STEPS.ORDDIKTAT,
				formattedResults,
				candidateGrade
			)
				.then(() => {
					if (!this.state.isSubmitting) {
						this.setState({isSubmitting: true});
						onGoToNextStep();
					}
				})
				.catch(() => {
					this.setState({isSubmitting: false});
				});
		} else {
			this.setState({
				currentSubstepIndex: currentSubstepIndex + 1,
			});
			setTimeout(() => {
				window.scrollTo(0, 0);
			});
		}
	}

	render() {
		const {currentSubstepIndex} = this.state;

		const CurrentSubStep = subStepsDE[currentSubstepIndex];
		const currentTitle = titlesDE[currentSubstepIndex];

		return (
			<div>
				<h1 className="lit-page-title">{currentTitle}</h1>
				<CurrentSubStep
					onNextStep={this.handleNextSubstep}
					refs={this.audioRefs}
				/>
			</div>
		);
	}
}

const mapStateToProps = (state) => {
	const {candidateGrade} = state;
	return {
		candidateGrade,
	};
};

const mapDispatchToProps = {
	onGoToNextStep: goToNextStep,
	onSetTestStepAnswers: setTestStepAnswers,
};

export default connect(mapStateToProps, mapDispatchToProps)(Orddiktat);
